import React, { Component } from 'react';
import { Icon, Popover } from 'antd';
import { List, Toast, Modal, WhiteSpace, Carousel } from 'antd-mobile';
import { CommonlyHead } from '../common/headnav';
import AddCalendar from "../../components/addcalendar";
import * as services from '../projects/services';
import * as fun from '../../components/common';
import imgURL from '../../res/images/logo.png';
import { createBrowserHistory } from "history";
import './style.less';
const Item = List.Item;
const history = createBrowserHistory();
let cont = 0;
export default class PackDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            packageid: this.props.match.params.packageid,
            packagename: this.props.match.params.packagename,
            typeid: this.props.match.params.typeid,
            data: [],
            dataItem: [],
            packItemCount: 0,
            logoPic: [],
            visible: false,
            packageType: 0,
            mcData: [],
            mcmo: '',
            totalprice: 0,
            rprice: 0,
            dataPic: ['1', '2', '3'],
            gender:0,
        }
    }
    componentDidMount() {
        if (parseInt(this.state.typeid) === 2) {
            services.GetCrmPackdetail(this.state.packageid, '正在查询请稍后').then(value => {
                if (value.status === 0) {
                    this.setState({packagename: value.result.name, gender: value.result.gender, packItemCount: value.result.itemCount,data: value.result, dataItem: value.result.itemTypes, mcmo: value.result.mccode, rprice: value.result.realprice, totalprice: value.result.marketprice, packageType: 2 }, () => {
                        //获取排班信息
                        services.GetJsonExamDate(value.result.mccode, '').then(mdata => {

                            this.setState({ mcData: mdata.result.sc }, () => {
                            });
                        })
                    });
                } else {
                    Toast.fail(value.message);
                }
            });
        } else {
            services.GetPackdetail(this.state.packageid, '正在查询请稍后').then(value => {
                if (value.status === 0) {
                    let picture = imgURL;
                    if (value.result.picture.length > 0) {
                        picture = value.result.picture[0].smallpicpath;
                    }
                    let packname = value.result.packname;
                    let mcName = value.result.mcName;
                    let url = global.constants.wx_tijian + this.props.match.url;
                    fun.wxshare(url, packname, mcName, picture);
                    this.setState({
                        gender: value.result.gender,
                        packItemCount: value.result.packItemCount,
                        data: value.result, dataItem: value.result.packItem, dataPic: value.result.picture, logoPic: value.result.mcLogo, mcmo: value.result.mcNo, rprice: value.result.realprice, totalprice: value.result.marketprice, packagename: value.result.packname

                    }, () => {
                        //获取排班信息
                        services.GetJsonExamDate(value.result.mcNo, '').then(mdata => {
                            this.setState({ mcData: mdata.result.sc }, () => {
                            });
                        })
                    });
                } else {
                    Toast.fail(value.message, 2);
                }
            });
        }

    }


    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {

        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {

        this.setState({
            visible: false,
        });
    };
    onClose = key => () => {
        this.setState({
            visible: false,
        });
    }
    goCustom = (e) => {
        history.push('/package/custom/' + this.state.mcmo + '/' + this.state.packageid+ '/' + this.state.gender) // 强制跳转
        history.go();
    }
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }
    //加入购物车
    AddCart = (e) => {
        history.push(`/addcart/${this.state.packageid}/${1}`);
        history.go();
    }
    //确认套餐
    AddCart2 = () => {
        const dataItem = this.state.dataItem;
        let orderment = JSON.parse(localStorage.getItem('orderment'));
        let ids = '';

        if (parseInt(this.state.packageType) === 2) {
            dataItem.forEach((value) => {
                value.children.forEach((item) => {
                    ids += item.itemid + ',';
                })
            })
        } else {
            dataItem.forEach((value) => {
                value.children.forEach((item) => {
                    ids += item.itemId + ',';
                })
            })
        }
        var reg = /,$/gi;
        ids = ids.replace(reg, "");
        orderment = {
            gender:this.state.gender,
            packageid: this.state.packageid, packageType: this.state.packageType, packagename: this.state.packagename, ids: ids, cardid: orderment.cardid, mcno: this.state.mcmo,
            payprice: this.state.rprice
        };
        localStorage.setItem('orderment', JSON.stringify(orderment));
        history.push(`/members/orderment/add/${orderment.cardid}/0/null`);
        history.go();
    }
    goback = () => {
        history.goBack();
    }
    render() {
        cont++;
        const { packagename, data, dataItem, dataPic, mcData } = this.state;
        var footerhtml;
        if (parseInt(this.state.typeid) === 0) {
            footerhtml = (
                <div className="footer">
                    <div className="footerbox footerbox2">
                        {
                            !!data.iscustomize === false ? <div className="fbigBtn customBtn" onClick={() => { this.goback() }} >返回重选</div> :

                                <div className="fbigBtn customBtn" onClick={() => { this.goCustom(this) }} >自定义套餐</div>
                        }
                        <div className="fbigBtn cartBtn" onClick={() => { this.AddCart() }}   >加入购物车</div>
                    </div>
                </div>
            );
        } else if (parseInt(this.state.typeid) === 1) {
            footerhtml = (
                <div className="footer">
                    <div className="footerbox footerbox2">
                        {
                            !!data.iscustomize === false ? <div className="fbigBtn customBtn" onClick={() => { this.goback() }} >返回重选</div> :
                                <div className="fbigBtn customBtn" onClick={() => { this.goCustom(this) }} >自定义套餐</div>
                        }
                        <div className="fbigBtn cartBtn" onClick={() => { this.AddCart2() }}   >确认套餐</div>
                    </div>
                </div>
            );
        } else {
            footerhtml = (
                <div className="footer">
                    <div className="footerbox footerbox2">
                        <div className="fbigBtn customBtn" onClick={() => { this.goback() }} >返回重选</div>
                        <div className="fbigBtn cartBtn" onClick={() => { this.AddCart2() }}   >确认套餐</div>
                    </div>
                </div>
            );
        }
        return (
            <div className="package">
                <CommonlyHead barname={packagename} />
                {
                    !!dataPic === false && cont > 1 ? <div key={'cc'} className="packdimg"><img alt="" src={require('../../res/images/h_zw.jpg')} /></div> :

                        dataPic.length > 1 ?
                            <Carousel className="space-carousel"
                                autoplay
                                infinite
                                speed={500}
                                autoplayInterval={4000}            >
                                {dataPic.map((picture, index) => (
                                    <div key={index} className="packdimg"
                                    >
                                        <img
                                            src={picture.picpath === '' || picture.picpath === null ? require('../../res/images/h_zw.jpg') : picture.picpath}
                                            alt=""
                                            style={{ width: '100%', verticalAlign: 'top', minHeight: '260px' }}
                                            onLoad={() => {
                                                this.setState({ imgHeight: 'auto' });
                                            }}
                                        />

                                    </div>
                                ))}
                            </Carousel>
                            :
                            dataPic.map((picture, index) => (
                                <div key={index} className="packdimg"><img alt="" src={picture.picpath === '' || picture.picpath === null ? require('../../res/images/h_zw.jpg') : picture.picpath} /></div>
                            ))
                }
                <WhiteSpace size='sm' />
                <List className="my-list">
                    <Item className="first"><span className='title'>体检中心:</span><span>{data.mcName}{data.mcname}</span></Item>
                    <Item><span className='title'>套餐价格：</span><span className="fontprice">{data.realprice}</span>
                        {
                            parseFloat(data.marketprice) === parseFloat(data.realprice) ? '' :

                                <span className="fontprice fontprice2">{data.marketprice}</span>
                        }</Item>
                    <Item extra="查看最近可约时间" arrow="horizontal" onClick={() => { this.showModal() }}><span className='title'>该医院需要在体检日前3天预约</span></Item>
                    {
                        !!data.crowd === false ? '' :
                            <Item><span className='title'>适应人群：</span><span>{data.crowd}</span></Item>
                    }
                    {
                        !!data.examTime === false ? '' :
                            <Item><span className='title'>体检时间：</span><span>{data.examTime}</span></Item>
                    }
                    {
                        !!data.addRess === false ? '' :
                            <Item><span className='title'>体检地址：</span><Icon type="environment" theme="outlined" style={{ fontSize: '14px', color: '#32a128' }} />{data.addRess}</Item>

                    }
                </List>
                <div className="transfertips">
                    温馨提示：因体检耗材或工本费产生的价格差异，按照实际体检金额多退少补
        </div>
                <Modal
                    title="排班日历"
                    visible={this.state.visible}
                    transparent
                    maskClosable={true}
                    onClose={this.handleOk}
                    closable={true}      >
                    {mcData.length > 0 ? <AddCalendar cm={mcData} isClickable={false} /> : ''}
                </Modal>
                <div className="xmtitle">体检项目（<span className="y">{this.state.packItemCount}个</span>）</div>
                <table className="packtable">
                    <tbody>
                        <tr>
                            <th >项目名称</th>
                            <th>价格</th>
                        </tr>
                        {
                            dataItem.map((datalist, index) => (
                                <tr key={index} >
                                    <td colSpan="2">
                                        <table className="ttable" >
                                            <tbody>
                                                <tr key={'c'} ><td colSpan="2" className="tcd"  >{datalist.shortName}</td></tr>
                                                {
                                                    datalist.children.map((data, index2) => (
                                                        <tr key={index2} >
                                                            <td>{data.itemName}{data.name}{!!data.description === false ? '' :
                                                                <Popover placement="bottom" content={'项目描述：' + data.description} trigger="click">
                                                                    <Icon type="info-circle" style={{ fontSize: '10px', color: '#32a128', marginLeft: '3px' }} />
                                                                </Popover>
                                                            }</td>
                                                            <td>￥{data.marketprice}{data.price}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ))
                        }
                        {
                            <tr><td colSpan="2" className="trright">合计：{this.state.totalprice}</td></tr>
                        }
                    </tbody>
                </table>
                {
                    !!data.description === false ? '' :

                        <table className="packtable">
                            <tbody>
                                <tr>
                                    <th >套餐描述</th>
                                </tr>
                                <tr>
                                    <td className="description">
                                        <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                }
                <WhiteSpace className="deWhiteSpace" />
                {footerhtml}
            </div>
        );
    }
}